import ViewCanvas from "./ViewCanvas";
import Tags from "./Tags";
import { DATA_STORE } from "./DataStore";
import { isMobileLayout, scroll } from "./utils";
import Bookmark from "./layout/Bookmark";
import AxL from "./axl";
import EventEmitter from "eventemitter3";

export default class Content extends EventEmitter {
  constructor(
    container,
    category,
    imagesDict,
    imagesByCat,
    USE_WORKER,
    index,
    isBookmark,
    scope
  ) {
    super();
    this.container = container;
    this.USE_WORKER = USE_WORKER;
    this.imagesByCat = imagesByCat;
    this.imagesDict = imagesDict;
    this.category = category;
    this.headline = category;
    this.isBookmark = isBookmark;
    this.axl = scope.axl;
    this.scope = scope;
    this.newContainer = document.createElement("div");

    // pool of images to load
    this.pool = [];
    // collection of tags
    this.tags = [];

    this.handlers = {
      share: this.onShare.bind(this),
    };

    //random distribution of images
    let rnd = 0.4;
    // rnd = Math.random();

    // Base on the index we use a different layout
    //  0.4 means the regular 3 columns
    //  0.6 means the 2 columns with one double on the left
    //  0.8 means the 2 columns with one double on the right
    // we try to alternate the layout
    if (index % 4 == 0) rnd = 0.4;
    if (index % 4 == 1) rnd = 0.6;
    if (index % 4 == 2) rnd = 0.4;
    if (index % 4 == 3) rnd = 0.8;
    //special cases
    // if there is a single image in the category we use the double layout
    // if there is 2 images in the category we use the 2 columns layout with a big one on the right
    // if there is 3 images in the category we use the 3 columns layout
    if (this.imagesByCat[this.category].length == 1) rnd = 0.6;
    if (this.imagesByCat[this.category].length == 2) rnd = 0.8;
    if (this.imagesByCat[this.category].length == 3) rnd = 0.4;
    // the switch is also set for a random distribution

    if (isMobileLayout()) {
      this.setContent();
    } else {
      switch (true) {
        case rnd > 0.75:
          this.setMasonryContent(1);
          break;
        case rnd > 0.5:
          this.setMasonryContent(0);
          break;
        default:
          this.setContent();
      }
    }
  }

  set headline(val) {
    const headline = document.createElement("h2");
    headline.innerHTML = val.split("/").join("<br/>").slice(5).toUpperCase();
    this._headline = headline;
  }
  get headline() {
    if (this.isBookmark) {
      const shareWrapper = document.createElement("div");
      shareWrapper.classList.add("personalShare");
      shareWrapper.innerHTML = `share`;
      if (!Bookmark.HIDE_SHARING) shareWrapper.classList.add("show");
      const span = document.createElement("span");
      span.classList.add("material-icons");
      span.textContent = "share";
      shareWrapper.addEventListener("click", this.handlers.share);
      shareWrapper.appendChild(span);
      this._headline.appendChild(shareWrapper);
      // this._headline += `<span class="material-icons share">share</span>`;
    }
    return this._headline;
  }
  get detail() {
    return this._detail;
  }

  async setImageLayout() {
    this.newContainer.classList.add(this.isMasonry ? "masonry" : "content");
    // get the images for this category
    const images = this.imagesByCat[this.category];

    // imagesDict is index with RECTO images
    let subWrapper = null;

    // pool of images to load
    this.pool = [];
    // collection of tags
    this.tags = [];

    images.forEach((verso, i) => {
      const recto = DATA_STORE.getAssetRecto(verso);
      // remove that condition as we don't use the recto anymore
      if (this.imagesDict[recto]) {
        //
        const wrapper = document.createElement("div");
        wrapper.classList.add("wrapper");

        // add image
        // console.log(recto);
        const view = new ViewCanvas(
          this.imagesDict[recto],
          recto,
          verso,
          this.USE_WORKER,
          true
        );
        wrapper.appendChild(view.dom);
        // add a clickable BOOKMARK button
        new Bookmark(view.dom, verso, this.scope);

        // add image to queue
        this.pool.push(view);

        // TODO fix link
        const gac_link = document.createElement("button");
        gac_link.classList.add("gac-link");
        gac_link.classList.add("material-icons");
        gac_link.setAttribute("tabindex", 1);
        gac_link.innerHTML = "open_in_new";

        const url = `asset/${DATA_STORE.assets[verso].par}?childassetid=${recto}`;
        gac_link.setAttribute("url", url);
        gac_link.addEventListener("click", (e) => {
          e.preventDefault();
          scroll.y = window.scrollY;
          console.warn("TODO: fix link (original)");
          const url = e.target.getAttribute("url");
          console.log(url);
          console.log("https://artsandculture.google.com/preview/" + url);
          this.axl.sendMessage(AxL.ChildToHost.NAVIGATE, url);
        });
        wrapper.append(gac_link);

        // const link = document.createElement("a");
        // link.setAttribute("value", recto);
        // link.innerHTML = "open_in_new";
        // gac_link.append(link);

        // add text
        const sentenceElement = document.createElement("p");
        sentenceElement.classList.add("sentence");
        let text = DATA_STORE.getAssetText(verso); // .replace( /<br>/g, " " );

        sentenceElement.innerHTML = text;
        wrapper.appendChild(sentenceElement);

        //test if the tags should be displayed

        const tags = DATA_STORE.getAssetTags(verso).filter((tag) => {
          const count = DATA_STORE.tagsScore[tag];
          return (
            DATA_STORE.tagsScore[tag] != undefined && count > 4 && count < 100
          );
        });
        if (tags.length != 0) {
          const tags = new Tags(verso);
          wrapper.appendChild(tags.domElement);
        }

        if (this.isMasonry)
          if (this.n == 0) {
            if (i % 5 == 0) {
              this.columns[0].appendChild(wrapper);
              subWrapper = document.createElement("div");
              subWrapper.classList.add("subWrapper");
              wrapper.appendChild(subWrapper);
            } else if (i % 5 == 2 || i % 5 == 3) {
              subWrapper.appendChild(wrapper);
            } else if (i % 5 == 1 || i % 5 == 4) {
              this.columns[1].appendChild(wrapper);
            }
          } else {
            if (i % 5 == 1 && i != 0) {
              this.columns[1].appendChild(wrapper);
              subWrapper = document.createElement("div");
              subWrapper.classList.add("subWrapper");
              wrapper.appendChild(subWrapper);
            } else if (i % 5 == 3 || i % 5 == 4) {
              subWrapper.appendChild(wrapper);
            } else if (i == 0 || i % 5 == 0 || i % 5 == 2) {
              this.columns[0].appendChild(wrapper);
            }
          }
        else this.newContainer.appendChild(wrapper);
      }
    });
  }

  async resize() {
    if (document.body.classList.contains("modern")) this.isModern = true;
    else this.isModern = false;
    if (this.isMasonry && !this.isModern) {
      //remove previous SVGs
      let column1Height = 42; //default margins
      Array.from(this.columns[0].children).forEach((wrapper) => {
        // console.log(wrapper);
        column1Height += wrapper.offsetHeight;
      });
      let column2Height = 42; //default margins
      Array.from(this.columns[1].children).forEach((wrapper) => {
        column2Height += wrapper.offsetHeight;
      });
      const limit = 150;
      if (column1Height < column2Height - limit && !this.svg) {
        this.svg = document.createElement("div");
        this.svg.classList.add("svg");
        // this.svg.innerHTML = await DATA_STORE.getRandomSVG();
        this.svg.innerHTML = await DATA_STORE.getRandomPNG();
        this.columns[0].appendChild(this.svg);
        this.columns[0].getElementsByClassName("svg")[0].style.maxHeight = `${
          column2Height - column1Height - 20
        }px`;
      } else if (column2Height < column1Height - limit && !this.svg) {
        this.svg = document.createElement("div");
        this.svg.classList.add("svg");
        // this.svg.innerHTML = await DATA_STORE.getRandomSVG();
        this.svg.innerHTML = await DATA_STORE.getRandomPNG();
        this.columns[1].appendChild(this.svg);
        this.columns[1].getElementsByClassName("svg")[0].style.maxHeight = `${
          column1Height - column2Height - 20
        }px`;
      }

      //  !! SVG COULD CHANGE COLUMN..... SO CHECK AGAIN

      if (Math.abs(column1Height - column2Height) < limit && this.svg) {
        this.svg.classList.add("hidden");
      } else if (this.svg) {
        try {
          this.svg.classList.remove("hidden");
          this.svg.getElementsByClassName("svg")[0].style.maxHeight = `${
            Math.abs(column1Height - column2Height) - 20
          }px`;
        } catch (err) {
          console.warn("Content.resize:  SVG is not happy ");
        }
      }
    }
  }

  setMasonryContent(n) {
    this.n = n;
    this.columns = [];
    this.isMasonry = true;
    // create n flex colunms
    for (let i = 0; i < 2; i++) {
      const column = document.createElement("div");
      column.classList.add("flex-column");
      if (i == n) column.classList.add("double");
      this.newContainer.appendChild(column);
      this.columns.push(column);
    }
    // this.headline = this.category;
    this.columns[0].appendChild(this.headline);
    this.setImageLayout();
  }

  setContent() {
    // this.headline = this.category;
    this.newContainer.appendChild(this.headline);
    this.setImageLayout();
  }

  onShare() {
    console.log("BOOK MARK SELECTION", Bookmark.selection);
    if (this.axl && Bookmark.selection.length > 0) {
      this.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {
        bookmarks: Bookmark.selection,
      });
      this.axl.sendMessage(AxL.ChildToHost.SHARE, {
        title:
          "Discover my personal edition of the Daily Herald made with @googlearts and @MediaMuseum",
      });

      this.scope.tracker.track("SHARE");
    }
  }

  load() {
    // no more images to load
    if (this.pool.length == 0) {
      this.emit("content-loaded-before", this);
      this.container.appendChild(this.newContainer);
      this.emit("content-loaded", this);
      return;
    }

    // prelaod an image
    const view = this.pool.shift();
    view.load(
      async () => {
        // console.log(
        //   "view loaded ",
        //   this.category,
        //   ":",
        //   this.pool.length,
        //   "images left"
        // );
        this.emit("image-loaded");
        this.load();
      },
      (err) => {
        console.warn("error", err, view);
        this.load();
      }
    );
    return;
  }
}
